// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#eidnumber {\n  height: 50px;\n  padding: 7px 16px;\n  width: 100%;\n  font-size: 16px;\n  border-radius: 10px;\n  border: 1px solid #ced1d6;\n  box-sizing: border-box;\n}\n.errorMsj {\n  color: #cec0bc;\n  padding: 4px;\n}\n.MuiInputAdornment-positionEnd {\n  color: #0088FF;\n  margin-left: 0;\n  margin-right: 16px;\n}\n@media (max-width: 600px){\n  #eidnumber {\n    font-size: 12px;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
